import { constants } from "../constants";
import { StringFormat } from "../Util/stringutil";
import { Status } from "./entity/Status";
import { myFetch } from "./myFetch";

export default interface IIntegrationOperation {
  getCorpIntegrationsAuthURLAync(
    corpId: number,
    integrationType: string
  ): Promise<Status<string>>;

  deleteCorpIntegrationAsync(corpId: number): Promise<Status<null>>;

  integrationStatusAsync(corpId: number): Promise<Status<null>>;
}

export class IntegrationOperation implements IIntegrationOperation {
  async integrationStatusAsync(corpId: number): Promise<Status<null>> {
    const response = await myFetch<Status<null>>(
      `${constants.BASE_URL}${StringFormat(constants.TEST_INT_STATUS, corpId)}`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: ``,
        }),
      }
    );

    const data = await response.json();
    return data;
  }
  async deleteCorpIntegrationAsync(corpId: number): Promise<Status<null>> {
    const response = await myFetch<Status<null>>(
      `${constants.BASE_URL}${StringFormat(constants.DELETE_INT_URL, corpId)}`,
      {
        method: "DELETE",
        headers: new Headers({
          Authorization: ``,
        }),
      }
    );

    const data = await response.json();
    return data;
  }
  async getCorpIntegrationsAuthURLAync(
    corpId: number,
    integrationType: string
  ): Promise<Status<string>> {
    const response = await myFetch<Status<string>>(
      `${constants.BASE_URL}${StringFormat(
        constants.GET_INT_AUTH_URL,
        corpId,
        integrationType
      )}`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: ``,
        }),
      }
    );

    const data = await response.json();
    return data;
  }
}
